import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";
import { ServiceRoute } from "../../base/service-route";
import { CommonHttpOption } from "../../base/common-http-option";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class SubsidiaryPlacementService {
  constructor(private coreService: CoreService) {}
    // add Placement 
    addPlacement(command: any): Observable<any> {
      return this.coreService.post(
        ServiceRoute.subsidiary.placement.aghPlacementAdd,
        command,
        new CommonHttpOption().headers
      );
    }
    // Placement Check 
    placementCheck(command: any): Observable<any> {
      return this.coreService.post(
        ServiceRoute.subsidiary.placement.aghPlacementCheck,
        command,
        new CommonHttpOption().headers
      );
    }
}
